module.exports = __webpack_public_path__ + "static/media/m16.32633167.jpg";